import React from 'react';

import HashtagList from 'components/hashtag/HashtagList';

const Hashtags = () => <HashtagList />;
export default Hashtags;
